import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const isAuthenticated = () => {
    const token = localStorage.getItem('accessToken');
    if (!token) {
        return false;
    }
    try {
        const decoded = jwtDecode(token);
        if (decoded.exp * 1000 < Date.now()) {
            localStorage.removeItem('accessToken');
            return false;
        }
    } catch (e) {
        return false;
    }
    return true;
};

const ProtectedRoute = () => {
    const auth = isAuthenticated(); 

    return auth ? <Outlet /> : <Navigate to="/login" />;
};

export default ProtectedRoute;
